import Swal from "sweetalert2";

export function loadingPopup(title = "Loading...", text) {
    Swal.fire({
        icon: "info",
        title: title,
        text: text,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => Swal.showLoading()
    });
}

/**
 * /
 * @param {string} title "Success" default
 * @param {string} position "bottom-end" default
 * @param {string} text
 */
export function successToast(text, title = "Success", position = "bottom-end") {
    Swal.fire({
        icon: "success",
        title: title,
        text: text,
        toast: true,
        timer: 4000,
        timerProgressBar: true,
        position: position,
        showConfirmButton: false,
        backdrop: false
    });
}

/**
 *
 * @param {HttpStatusCode} err
 */
export function genericErrorPopup(err) {
    Swal.fire({
        icon: "error",
        title: "Something went wrong...",
        html: `<small>(code: ${err.status})</small><p class="lead">${err.statusText}</p>`
    });
}

export function ajaxErrorPopUp(status, error, title = undefined) {
    switch (status) {
    case 404:
        Swal.fire({
            title: title || "Not found",
            icon: "error",
            text: error
        });
        break;
    case 403:
        Swal.fire({
            title: title || "Not authorised",
            icon: "error",
            text: error
        });
        break;
    case 500:
        Swal.fire({
            title: title || "Internal server error",
            icon: "error",
            text: error
        });
        break;
    case 400:
        Swal.fire({
            title: title || "Something went wrong",
            icon: "error",
            text: error
        });
        break;
    case 409:
        Swal.fire({
            title: title || "Server conflict",
            icon: "error",
            text: error
        });
        break;
    case 402:
        Swal.fire({
            title: title || "Payment required",
            icon: "error",
            text: error
        });
        break;
    default:
        Swal.fire({
            title: title || "Unknown Error",
            icon: "error",
            text: "An unknown error has occurred, please contact us"
        });
    }
}


export function confirmationPopup(confirmCallback, deniedCallback, opts = { title: "Are you sure?", text: "You won't be able to revert this!", confirmText: "Confirm!" }) {

    opts = Object.assign({ title: "Are you sure?", text: "You won't be able to revert this!", confirmText: "Confirm!" }, opts);

    Swal.fire({
        title: opts.title,
        text: opts.text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        //  cancelButtonColor: '#3085d6',
        confirmButtonText: opts.confirmText
    }).then((result) => {
        if (result.isConfirmed) {

            confirmCallback(result);

            // $.ajax({
            //     url: url,
            //     method: 'DELETE',
            //     success: () => {
            //         Swal.fire({
            //             title: 'Successfully unfollowed!',
            //             icon: 'success',
            //             position: 'top-end',
            //             timer: 3000,
            //             toast: true,
            //             showConfirmButton: false,
            //             backdrop: false
            //         });
            //         $(row).addClass('line-through bg-secondary');
            //         setTimeout(function () { table.ajax.reload(); }, 3000);
            //     },
            //     error: function (xhr, type, error) {
            //         ajaxErrorPopUp(xhr.status, error);
            //     }
            // });
        } else {
            deniedCallback(result);
        }
    })
}